<template>
  <div class="CartPrice">
    <div v-if="(isRenting || delivery.type == 'renting')" class="CartPrice-container">
      <p class="priceBig" :inner-html.prop="originalPrice | formatPrice(2)"></p>
      <small class="ttc"> / mois</small>
    </div>
    <div v-else>
      <div v-if="specialPrice && specialPrice > 0" class="CartPrice-container">
        <span v-if="devider && devider > 1">{{ devider }}x </span>
        <p class="priceBig" :inner-html.prop="specialPrice | formatPrice(2)"></p>
        <small class="ttc">TTC</small>
        <div class="CartPrice-specialPrice">
          <p :inner-html.prop="originalPrice | formatPrice(2)"></p>
        </div>
      </div>
      <div v-else-if="originalPrice > 0" class="CartPrice-container">
        <span v-if="devider && devider > 1">{{ devider }} X </span>
        <p class="priceBig" :inner-html.prop="originalPrice | formatPrice(2)"></p>
        <small class="ttc">TTC</small>
      </div>
    </div>
  </div>
</template>

<script>
import "@/includes/Cart/CartPrice/CartPrice.scss";
import { mapGetters } from "vuex";

export default {
  name: "CartPrice",

  props: {
    originalPrice: {
      type: [String, Number],
      required: true,
      default: 0,
    },
    specialPrice: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    devider: {
      type: [String, Number],
      required: false,
      default: 0,
    },
    ecoTaxe: {
      type: [String, Number],
      required: true,
    },
    isRenting: {
      type: [String, Number],
      required: false,
      default: false,
    },
  },

  computed: {
    ...mapGetters({
      delivery: "getCurrentCartDelivery"
    }),
  },
};
</script>
